class HydrationBundleSlider extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('.hydration-bundle-track');
    this._slides = Array.from(this.querySelectorAll('.hydration-bundle-card'));
    this._dots = Array.from(this.querySelectorAll('.hydration-bundle-dot'));
    this._index = 0;
    this._timer = null;

    if (this._slides.length <= 1) return;

    this._dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this._goTo(i);
        this._resetAutoplay();
      });
    });

    this._setupSwipe();
    this._startAutoplay();
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  _goTo(index) {
    this._index = ((index % this._slides.length) + this._slides.length) % this._slides.length;
    this._track.style.transform = `translateX(-${this._index * 100}%)`;
    this._dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this._index));
    this._syncProducts();
  }

  _syncProducts() {
    const container = this.closest('.hydration-bundle-container');
    if (!container) return;
    container.querySelectorAll('[data-hb-products]').forEach(el => {
      el.style.display = el.dataset.hbProducts === String(this._index) ? 'grid' : 'none';
    });
  }

  _startAutoplay() {
    if (this.dataset.autoplay !== 'true') return;
    const speed = parseInt(this.dataset.speed, 10) || 4000;
    this._timer = setInterval(() => this._goTo(this._index + 1), speed);
  }

  _resetAutoplay() {
    clearInterval(this._timer);
    this._startAutoplay();
  }

  _setupSwipe() {
    let startX = 0;
    let dragging = false;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        this._goTo(diff > 0 ? this._index + 1 : this._index - 1);
        this._resetAutoplay();
      }
    }, { passive: true });

    this.addEventListener('dragstart', (e) => e.preventDefault());

    this.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      dragging = true;
      this.classList.add('is-dragging');
    });
    this.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      e.preventDefault();
    });
    this.addEventListener('mouseup', (e) => {
      if (!dragging) return;
      dragging = false;
      this.classList.remove('is-dragging');
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        this._goTo(diff > 0 ? this._index + 1 : this._index - 1);
        this._resetAutoplay();
      }
    });
    this.addEventListener('mouseleave', () => {
      dragging = false;
      this.classList.remove('is-dragging');
    });
  }
}

customElements.define('hydration-bundle-slider', HydrationBundleSlider);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hydration-bundle-products').forEach(el => {
    let isDown = false;
    let hasDragged = false;
    let startX, scrollLeft;

    el.addEventListener('mousedown', e => {
      isDown = true;
      hasDragged = false;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
      e.preventDefault();
    });
    el.addEventListener('mouseup', () => { isDown = false; el.classList.remove('is-dragging'); });
    el.addEventListener('mouseleave', () => { isDown = false; el.classList.remove('is-dragging'); });
    el.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const walk = e.pageX - el.offsetLeft - startX;
      if (Math.abs(walk) > 5) hasDragged = true;
      el.scrollLeft = scrollLeft - walk * 1.5;
    });
    el.addEventListener('click', e => {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  });
});
